import { useAdminStudents } from "../../../store/admin";
import { ModalOverlay, ModalHeader } from "../common/Modal";

// ===== SUSPEND / REACTIVATE CONFIRM MODAL (PATCH /api/admin/students/:id/status) =====
const SuspendConfirmModal = ({ isOpen, onClose, student, onConfirm }) => {
  const { statusUpdateLoading, statusUpdateError } = useAdminStudents();
  if (!isOpen || !student) return null;

  const confirmingSuspend = student.isActive;

  return (
    <ModalOverlay onClose={onClose} width="440px">
      <ModalHeader
        title={confirmingSuspend ? "Suspend Student" : "Reactivate Student"}
        onClose={onClose}
      />
      <p style={{ color: "#334155", fontSize: "14px", lineHeight: 1.6 }}>
        {confirmingSuspend ? (
          <>
            You are about to <strong>suspend</strong> <strong>{student.name}</strong>. They
            will no longer be able to sign in or access their courses.
          </>
        ) : (
          <>
            You are about to <strong>reactivate</strong> <strong>{student.name}</strong> and
            restore their access to the platform.
          </>
        )}
      </p>
      {statusUpdateLoading && (
        <p style={{ color: "#94a3b8", fontSize: "13px" }}>Updating status…</p>
      )}
      {statusUpdateError && (
        <p style={{ color: "#dc2626", fontSize: "13px" }}>{statusUpdateError}</p>
      )}
      <div style={{ display: "flex", gap: "10px" }}>
        <button
          onClick={onClose}
          style={{
            flex: 1,
            padding: "10px",
            background: "#f1f5f9",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: 500,
            color: "#475569",
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => onConfirm(student, confirmingSuspend ? "SUSPENDED" : "ACTIVE")}
          disabled={statusUpdateLoading}
          style={{
            flex: 1,
            padding: "10px",
            background: confirmingSuspend ? "#dc2626" : "#16a34a",
            border: `1px solid ${confirmingSuspend ? "#dc2626" : "#16a34a"}`,
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: 600,
            color: "#fff",
            opacity: statusUpdateLoading ? 0.6 : 1,
          }}
        >
          {confirmingSuspend ? "Suspend" : "Reactivate"}
        </button>
      </div>
    </ModalOverlay>
  );
};

export default SuspendConfirmModal;